// extracted by mini-css-extract-plugin
export default {"align-cc":"LocationCard_align-cc__8PK1I","align-lc":"LocationCard_align-lc__-AZhF","align-rc":"LocationCard_align-rc__leaAq","card":"LocationCard_card__mH45e"};